define('GaTeamsDataLayer',["jquery", "eventManager", "underscore"], function ($, eventManager, _) {
    "use strict";

    GaTeamsDataLayer.prototype._pushToDataLayer = function _pushToDataLayer(obj) {
        window.dataLayer = window.dataLayer || [];
        // clean
        window.dataLayer.push({ item_list_id: null, item_list_name: null, items: null });
        // push obj
        window.dataLayer.push(obj);
    }

    GaTeamsDataLayer.prototype._getPropertyPrice = function _getPropertyPrice($propertyInfo, selector) {
        var price = '';
        var lineForPrice = $propertyInfo.find(selector).text().trim();
        if (lineForPrice.length > 0) {
            price = this._extractNumber(lineForPrice);
        }

        return price;
    }

    GaTeamsDataLayer.prototype._extractNumber = function _extractNumber(text) {
        var numbers = text.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g);

        if (!numbers) {
            return '';
        }

        if (numbers.length > 0) {
            numbers = numbers[0];
        }

        return numbers;
    }

    // isDayMonthRange - if true then take date parts from start date only
    GaTeamsDataLayer.prototype._getDateParts = function _getDateParts(textLine, isDayMonthRange) {
        var year = "", month = "", day = "";

        if (!isDayMonthRange) {
            isDayMonthRange = false;
        }

        var textLines = textLine.replaceAll(",", "").split(" ");

        if (isDayMonthRange && _.contains(textLines, "–")) {
            textLines = _.reject(textLines, function (elm) { return elm === "–"; });
        }

        _.each(textLines, function (item) {
            // numbers only
            if (item.match(/^\d+$/)) {
                if (item.length === 4) {
                    if (!isDayMonthRange || (isDayMonthRange && year === "")) {
                        year = item;
                    }
                }
                else if (item.length === 1 || item.length === 2) {
                    if (!isDayMonthRange || (isDayMonthRange && day === "")) {
                        day = item;
                    }
                }
            }
            // months, quarters, half-years and others
            else {
                if (!isDayMonthRange || (isDayMonthRange && month === "")) {
                    month = item;
                }
            }
        }.bind(this));

        return { 'year': year, 'month': month, 'day': day };
    }

    GaTeamsDataLayer.prototype.runDataLayerCreation = function runDataLayerCreation() {
        var $contentWrapper;

        // handle team members on about page
        $contentWrapper = $('.content-page .team-members');
        if ($contentWrapper.length > 0) {
            this.handleTeamMembersList($contentWrapper);
        }

        // handle error page
        else if (document.body.classList.contains('error-page')) {
            this.handleErrorPage();
        }

    }

    GaTeamsDataLayer.prototype.handleTeamMembersList = function handleTeamMembersList($scope) {

        this.eventValues = {
            'event': 'view_item_list',
            'item_list_id': 'team_members_list',
            'item_list_name': 'team-members'
        };

        var items = [];

        var $allTiles = $scope.find('ul.search-results-list li .mm-tile');

        $allTiles.each(function (index, element) {
            var $tile = $(element);

            var $contentWrapper = $tile.find('.mm-content-wrapper');

            var agentName = $contentWrapper.find('h2').text().trim();
            var position = $contentWrapper.find('h3').text().trim();
            var userCode = $tile.attr('data-usercode');

            if (agentName) {
                items.push({
                    'item_name': agentName,
                    'item_category': position,
                    'quantity': this.defaultQuantity,
                    'userCode': userCode
                });

                // subscribe on team member click and track select_item event
                var $wholeTileLink = $tile.children('a');
                if ($wholeTileLink.length > 0) {
                    $wholeTileLink.on('click', function () {
                        this._pushToDataLayer({
                            'event': 'select_item',
                            'item_list_id': 'team_members_list',
                            'item_list_name': 'team-members',
                            'items': [{
                                'item_name': agentName,
                                'item_category': position,
                                'quantity': this.defaultQuantity,
                                'userCode': userCode
                            }]
                        });
                    }.bind(this));
                }
            }
        }.bind(this));

        this.eventValues.items = items;
        this._pushToDataLayer(this.eventValues);
    }

    GaTeamsDataLayer.prototype.handleSearchRendered = function handleSearchRendered(data) {
        //properties on properties page
        var $container = $('.team-properties-page .score-search-results');
        if ($container.length > 0) {
            this.handleProperties($container, 'team_properties_list', data);
        }

        //market reports and trends and perspectives on research page
        $container = $('.research-landing-page');
        var $scope = $(data);
        if ($container.length > 0 && $scope.length > 0) {
            this.handleResearches($scope, 'team_researches_list');
        }
    }

    GaTeamsDataLayer.prototype.handleProperties = function handleProperties($scope, itemListId, data) {

        this.eventValues = {
            'event': 'view_item_list',
            'item_list_id': itemListId,
            'item_list_name': 'properties'
        };

        var $allTiles = $scope.find('.mm-tile');

        var items = [];

        $allTiles.each(function (index, element) {
            var $tile = $(element);
            var $contentWrapper = $tile.find('.mm-content-wrapper');
            var $propertyWrapper = $tile.find('.mm-property-wrapper');

            var itemName = $contentWrapper.find('h2').text().trim();
            var itemCategory = $contentWrapper.find('h3').text().trim();
            var locationId = $propertyWrapper.find('.mm-location').text().trim() || '';
            var price = this._getPropertyPrice($propertyWrapper, '.mm-listing-price');
            var dealId = $tile.attr('data-dealid');

            if (itemName || itemCategory) {
                items.push({
                    'item_name': itemName,
                    'item_category': itemCategory,
                    'currency': this.defaultCurrency,
                    'price': price,
                    'location_id': locationId,
                    'quantity': this.defaultQuantity,
                    'deal_id': dealId
                });

                // subscribe on property click and track select_item event
                var $wholeTileLink = $tile.children('a');
                if ($wholeTileLink.length > 0) {
                    $wholeTileLink.on('click', function () {
                        this._pushToDataLayer({
                            'event': 'select_item',
                            'item_list_id': itemListId,
                            'item_list_name': 'properties',
                            'items': [{
                                'item_name': itemName,
                                'item_category': itemCategory,
                                'currency': this.defaultCurrency,
                                'price': price,
                                'location_id': locationId,
                                'quantity': this.defaultQuantity,
                                'deal_id': dealId
                            }]
                        });
                    }.bind(this));
                }
            }
        }.bind(this));

        this.eventValues.items = items;
        this._pushToDataLayer(this.eventValues);
    }

    GaTeamsDataLayer.prototype.handleResearches = function handleResearches($scope, itemListId) {

        this.eventValues = {
            'event': 'view_item_list',
            'item_list_id': itemListId,
            'item_list_name': 'researches',
        };

        var $allTiles = $scope.find('.mm-tile');

        var items = [];

        $allTiles.each(function (index, element) {
            var $tile = $(element);
            var $contentWrapper = $tile.find('.mm-content-wrapper');

            var researchName = $contentWrapper.find('h2').remove("br").text().trim().replaceAll("\n", "").replace(/\s\s+/g, " ");
            var researchType = $contentWrapper.find('h3').text().trim();

            var subtitle = $contentWrapper.find('.mm-subtitle p').text().trim();
            var dateParts = this._getDateParts(subtitle);

            if (researchName) {
                items.push({
                    'item_name': researchName,
                    'item_category': 'research',
                    'item_category2': researchType,
                    'item_category3': dateParts.year,
                    'item_category4': dateParts.month,
                    'quantity': this.defaultQuantity
                });

                // subscribe on research click and track select_item event
                var $wholeTileLink = $tile.children('a');
                if ($wholeTileLink.length > 0) {
                    $wholeTileLink.on('click', function () {
                        this._pushToDataLayer({
                            'event': 'select_item',
                            'item_list_id': itemListId,
                            'item_list_name': 'researches',
                            'items': [{
                                'item_name': researchName,
                                'item_category': 'research',
                                'item_category2': researchType,
                                'item_category3': dateParts.year,
                                'item_category4': dateParts.month,
                                'quantity': this.defaultQuantity
                            }]
                        });
                    }.bind(this));
                }

            }
        }.bind(this));

        this.eventValues.items = items;
        this._pushToDataLayer(this.eventValues);
    }

    GaTeamsDataLayer.prototype.handleErrorPage = function handleErrorPage() {
        var errorDescription, fatality = false;
        var errorCode = document.title.trim();

        if (!errorCode) {
            return;
        }

        switch (errorCode) {
            case "404":
                errorDescription = "Not Found";
                break;
            case "403":
                errorDescription = "Forbidden";
                break;
            case "500":
                errorDescription = "Internal Server Error";
                fatality = true;
                break;
            default:
                errorDescription = "Unknown Error";
                break;
        }

        this.eventValues = {
            'event': 'exception',
            'description': errorDescription,
            'fatal': fatality,
            'code': errorCode
        };

        this._pushToDataLayer(this.eventValues);
    }

    GaTeamsDataLayer.prototype.handleContactUsForm = function handleContactUsForm(submitData) {
        var formParams = new URLSearchParams(decodeURIComponent(submitData));

        var formName = formParams.get('formName') || 'contact-us';

        this.eventValues = {
            'event': 'form_submit',
            'form_name': formName
        };

        this._pushToDataLayer(this.eventValues);
    }

    function GaTeamsDataLayer() {
        Object.defineProperties(this, {
            executionTimeout: { writable: !1, enumerable: !0, configurable: !0, value: 600 /* 600 milliseconds */ },
            defaultCurrency: { writable: !1, enumerable: !1, configurable: !0, value: 'USD' /* currency: by default, use USD */ },
            defaultQuantity: { writable: !1, enumerable: !1, configurable: !0, value: 1 /* quantity: number of units of the property(by default is one) */ },
            eventValues: { writable: !0, enumerable: !0, configurable: !0, value: {} /* Object of event values for the dataLayer */ }
        });

        var self = this;

        eventManager.subscribe("team_properties_featured:resultsLoaded", function (data) {
            setTimeout(function () {
                // handle properties featured listing on home page
                this.handleProperties($('.home-page .featured-list'), 'team_properties_featured', data);
            }.bind(self), self.executionTimeout);
        });

        eventManager.subscribe("team_researches_related:resultsLoaded", function (data) {
            setTimeout(function () {
                // handle related researches on home page
                var $contentWrapper = $('.home-page .research-section .score-tile-grid .search-results-list');
                if ($contentWrapper.length > 0) {
                    this.handleResearches($contentWrapper, 'team_researches_related');
                }
            }.bind(self), self.executionTimeout);
        });

        eventManager.subscribe("search-rendered", function (data) {
            // handle search rendered
            self.handleSearchRendered(data);
        });

        eventManager.subscribe("team_contact_us_form:submitted", function (submitData) {
            return new Promise(function (resolve, reject) {
                self.handleContactUsForm(submitData);
                resolve();
            });
        });

        eventManager.subscribe("ModulesLoadedEvent", function (scope) {
            setTimeout(function () {
                this.runDataLayerCreation();
            }.bind(self), this.executionTimeout);
        });
    }

    return new GaTeamsDataLayer();
});
